import { formatDate } from '@core/utils/time'

export const PLACEHOLDER = '-'

export const formatDateValue = (value?: string) => {
    if (!value) {
        return PLACEHOLDER
    }
    const timestamp = new Date(value).getTime()
    if (Number.isNaN(timestamp)) {
        return PLACEHOLDER
    }

    return formatDate(value)
}

export const formatCertificateName = (key: string) => {
    const parts = key.split('_')
    if (parts.length > 2) return `${parts[0]} ${parts[1]}.${parts[2]}`
    if (parts.length > 1) return `${parts[0]} ${parts[1]}`
    return parts[0]
}

export const getActiveCertificates = (
    certs: TAssetCertificates | undefined
): string[] => {
    if (!certs) return []
    return Object.keys(certs)
        .filter((key) => certs[key as keyof TAssetCertificates])
        .map(formatCertificateName)
}

export const formatOpenPort = (port: TAssetOpenPort) =>
    `${port.transport_protocol} ${port.port_number}`
